import { Colors } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { buildComponentMetadata } from "@/components/pages_logged_in/program/components/componentMetadata";
import { MeetingStatistic } from "@/components/pages_logged_in/program/components/MeetingStatistic";
import { CARD_CLASSES } from "@/css/constants";
import { useGetProgramCoachingSessionsQuery } from "@/graphql";
import { MainComponent } from "@/types/programs";
import { ensureNonNullArray } from "@/utils/array";

interface MeetingSessionAnalyticsProps {
  component: MainComponent;
}

export function MeetingSessionAnalytics({
  component,
}: MeetingSessionAnalyticsProps) {
  const metaData = buildComponentMetadata({
    component: component,
    isProgramLead: true,
  });

  const { data } = useGetProgramCoachingSessionsQuery({
    variables: {
      programComponentId: component.id,
    },
  });

  const programCoachingSessions = ensureNonNullArray(
    data?.programCoachingSessions,
  );

  return (
    <Box
      px={[16, 24]}
      py={[16, 24]}
      flex={1}
      className={CARD_CLASSES}
      css={{ background: Colors.WHITE }}
    >
      <Box fontSize={18} fontWeight={600}>
        {metaData.analyticsTitle}
      </Box>
      {programCoachingSessions.map((session) => {
        return <MeetingStatistic session={session} key={session.id} />;
      })}
    </Box>
  );
}
